<template>
    <svg viewBox="0 0 143 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0)">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M49.313 22.1172C49.9054 20.7926 51.1466 19.8908 52.7832 19.8908C54.4197 19.8908 55.6329 20.6516 56.1407 22.1172H49.313ZM60.0341 23.8084C60.0341 19.7496 57.0714 16.5085 52.755 16.5085C48.6922 16.5085 45.4195 19.7777 45.4195 23.8367C45.4195 27.8953 48.4668 31.1647 52.868 31.1647C55.9161 31.1647 58.1085 29.6958 59.342 27.5902L56.2762 25.7639C55.6259 27.0105 54.3774 27.7826 52.8962 27.7826C50.8648 27.7826 49.5953 26.7677 49.1438 25.2175H60.0341V23.8084ZM138.724 23.8084C138.724 21.7228 137.2 20.0316 135.113 20.0316C132.968 20.0316 131.332 21.6382 131.332 23.8084C131.332 25.9786 132.968 27.6135 135.113 27.6135C137.2 27.6135 138.724 25.8942 138.724 23.8084ZM127.551 23.8367C127.551 18.8482 131.219 16.5085 134.407 16.5085C136.241 16.5085 137.68 17.185 138.611 18.1713V10.3079H142.476V30.8827H138.611V29.3046C137.68 30.4039 136.185 31.1647 134.351 31.1647C131.36 31.1647 127.551 28.7971 127.551 23.8367ZM124.712 14.6455C125.989 14.6455 127.024 13.6114 127.024 12.3357C127.024 11.06 125.989 10.0259 124.712 10.0259C123.435 10.0259 122.4 11.06 122.4 12.3357C122.4 13.6114 123.435 14.6455 124.712 14.6455ZM122.78 16.7905H126.645V30.8827H122.78V20.5391L121.377 20.5389L122.78 16.7905ZM112.483 16.7905H116.32V19.1017C117.025 17.6361 118.295 16.7905 120.213 16.7905H121.765L120.364 20.5389H119.31C117.251 20.5389 116.348 21.6101 116.348 24.2312V30.8827H112.483V16.7905ZM90.7386 20.5954C90.7386 14.7328 95.1681 10.0259 101.262 10.0259C104.31 10.0259 106.874 11.1224 108.729 12.8698C109.485 13.5808 110.123 14.3998 110.629 15.2966L107.187 17.3822C105.917 15.0427 103.971 13.8308 101.29 13.8308C97.5379 13.8308 94.6319 16.9032 94.6319 20.5954C94.6319 24.3722 97.4816 27.3596 101.431 27.3596C104.422 27.3596 106.538 25.6686 107.271 23.0474H100.811V19.2989H111.503V20.8772C111.503 26.4015 107.554 31.1647 101.431 31.1647C94.9988 31.1647 90.7386 26.2889 90.7386 20.5954ZM86.0794 23.8084C86.0794 21.7228 84.556 20.0316 82.4683 20.0316C80.3241 20.0316 78.6876 21.6382 78.6876 23.8084C78.6876 25.9786 80.3241 27.6135 82.4683 27.6135C84.556 27.6135 86.0794 25.8942 86.0794 23.8084ZM74.907 23.8367C74.907 18.8482 78.5746 16.5085 81.7628 16.5085C83.5966 16.5085 85.0355 17.185 85.9666 18.1713V10.3079H89.8318V30.8827H85.9666V29.3046C85.0355 30.4039 83.5403 31.1647 81.7065 31.1647C78.7159 31.1647 74.907 28.7971 74.907 23.8367ZM60.9376 16.7905H64.7748V18.3688C65.6775 17.2131 67.0601 16.5085 68.6681 16.5085C71.9971 16.5085 74.0004 18.6506 74.0004 22.2863V30.8827H70.0787V22.7937C70.0787 20.9053 69.2041 19.806 67.4833 19.806C66.0161 19.806 64.8029 20.8207 64.8029 23.1882V30.8827H60.9376V16.7905ZM29.3787 27.4725L32.962 24.6538C33.9775 26.4015 35.5857 27.416 37.4193 27.416C39.4227 27.416 40.4949 26.1197 40.4949 24.7102C40.4949 23.0192 38.435 22.484 36.2345 21.8071C33.4698 20.9617 30.3944 19.8908 30.3944 15.9447C30.3944 12.6472 33.2724 10.0259 37.2502 10.0259C40.6077 10.0259 42.5261 11.2942 44.1908 13.0137L40.9461 15.4657C40.0999 14.1975 38.8867 13.5209 37.2783 13.5209C35.4446 13.5209 34.4574 14.5074 34.4574 15.8039C34.4574 17.3822 36.4321 17.9181 38.6326 18.6506C41.426 19.5524 44.5857 20.7926 44.5857 24.7387C44.5857 28.0079 41.99 31.1647 37.4476 31.1647C33.7238 31.1647 31.241 29.5866 29.3787 27.4725Z"
                fill="#212F38"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.27905 30.8825H16.5169V22.6528H8.27905V30.8825Z"
                fill="#9DD6E3"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0.0412598 22.6536H8.27911V14.4238H0.0412598V22.6536Z"
                fill="#9DD6E3"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0.0415039 30.8825H8.27936V22.6528H0.0415039V30.8825Z"
                fill="#3F72AB"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M16.5171 22.6536H24.7549V14.4238H16.5171V22.6536Z"
                fill="#00A9D1"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.27905 14.424H16.5169V6.19434H8.27905V14.424Z"
                fill="#00A9D1"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.27905 22.6535H16.5169V14.4238H8.27905V22.6535Z"
                fill="#2191C4"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M16.5171 14.424H24.7549V6.19434H16.5171V14.424Z"
                fill="#3F72AB"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M33.265 1.2225V6.02017H32.154V1.2225H30.4419V0.262695H34.9827L34.9809 1.2225H33.265Z"
                fill="#212F38"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M43.0808 6.01979H42.0284L40.7504 1.83089L39.4726 6.01979H38.4286L36.8179 0.235352L37.9838 0.251255L39.0549 4.32592L40.2577 0.262309H41.3685L42.5714 4.32592L43.6238 0.262309H44.7346L43.0808 6.01979Z"
                fill="#212F38"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M46.9258 6.02017H48.0366V0.262695H46.9258V6.02017Z"
                fill="#212F38"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M50.6104 6.02017V0.262695H51.7214V5.04388H53.6423L53.652 6.02017H50.6104Z"
                fill="#212F38"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M55.9578 6.02017H57.0686V0.262695H55.9578V6.02017Z"
                fill="#212F38"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M62.1226 1.07221C61.137 1.07221 60.5441 1.88152 60.5441 3.14155C60.5441 4.40157 61.137 5.21068 62.1226 5.21068C63.1165 5.21068 63.7096 4.40157 63.7096 3.14155C63.7096 1.88152 63.1084 1.07221 62.1226 1.07221ZM62.1144 6.12879C60.4771 6.12879 59.4167 4.92695 59.4167 3.1495C59.4167 1.3639 60.4855 0.154297 62.1309 0.154297C63.7849 0.154297 64.8286 1.35536 64.8286 3.13301C64.8286 4.91008 63.7682 6.12879 62.1144 6.12879Z"
                fill="#212F38"
            />
        </g>
        <defs>
            <clipPath id="clip0">
                <rect width="142.688" height="32" fill="white" />
            </clipPath>
        </defs>
    </svg>
</template>
